var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);}import React, { useEffect, useState } from 'react';
import { isObject } from 'lodash';
import { Translate } from "../../I18N";
import { Icon } from "../../UI";

import { prepareHTMLMediaView } from "../../../shared/fileUploadUtils";
import { MediaModal, MediaModalType } from "../../Metadata/components/MediaModal";
import MarkdownMedia from "../../Markdown/components/MarkdownMedia";









const getValue = (value) =>
isObject(value) && value.data ? value.data : value;

const prepareValue = (
value,
localAttachments) =>
{
  const valueString = getValue(value);
  const values = {
    data: valueString,
    fileURL: valueString,
    type: '',
    originalFile: isObject(value) ? value.originalFile : undefined
  };

  if (/^[a-zA-Z\d_]*$/.test(values.data)) {
    values.type = 'uploadId';
  }

  if (/^https?:\/\//.test(values.data)) {
    values.type = 'webUrl';
  }

  const supportingFile = localAttachments.find(
    (file) => values.data === (file.url || file.fileLocalID || `/api/files/${file.filename}`)
  );

  if (values.type === 'uploadId' && supportingFile) {
    values.originalFile = supportingFile;
    values.fileURL = prepareHTMLMediaView(supportingFile);
  }

  return _objectSpread(_objectSpread({}, values), {}, { supportingFile });
};

const MediaField = (props) => {
  const {
    value,
    onChange,
    type,
    localAttachments = [],
    formModel,
    name: formField,
    multipleEdition
  } = props;
  const [openModal, setOpenModal] = useState(false);
  const [imageRenderError, setImageRenderError] = useState(false);

  useEffect(() => {
    setImageRenderError(false);
  }, [localAttachments]);

  const handleCloseMediaModal = () => {
    setOpenModal(false);
  };

  const handleImageRemove = () => {
    onChange(null);
  };

  const file = prepareValue(value, localAttachments);
  const constructTimelinksString = (timelinks) => {
    if (!file || !file.data) {
      return null;
    }
    const timelinksObj = timelinks.reduce((current, timelink) => {
      current[`${timelink.timeHours}:${timelink.timeMinutes}:${timelink.timeSeconds}`] =
      timelink.label;
      return current;
    }, {});
    const [, fileLocalID] = file.data.match(/\(?(.*?)(, {|$)/) || ['', file.data];

    return {
      data: `(${fileLocalID}, ${JSON.stringify({ timelinks: timelinksObj })})`,
      originalFile: file.originalFile
    };
  };

  const updateTimeLinks = (timelinks) => {
    onChange(constructTimelinksString(timelinks));
  };

  useEffect(
    () => () => {var _file$supportingFile;
      if (file && (_file$supportingFile = file.supportingFile) !== null && _file$supportingFile !== void 0 && _file$supportingFile.serializedFile && file.fileURL) {
        URL.revokeObjectURL(file.fileURL);
      }
    },
    []
  );

  return /*#__PURE__*/(
    _jsx("div", { className: "search__filter--selected__media" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "search__filter--selected__media-toolbar" }, void 0, /*#__PURE__*/
    _jsx("button", { type: "button", onClick: () => setOpenModal(true), className: "btn" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "plus" }), " ", /*#__PURE__*/_jsx(Translate, {}, void 0, value ? 'Update' : 'Add file')
    ),

    file && file.data && /*#__PURE__*/
    _jsx("button", { type: "button", onClick: handleImageRemove, className: "btn" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "unlink" }), "\xA0 ", /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Unlink")
    )

    ),

    ((_file$supportingFile$) => {
      if (imageRenderError) {
        return /*#__PURE__*/(
          _jsx("div", { className: "media-error" }, void 0, /*#__PURE__*/
          _jsx(Translate, {}, void 0, "This file type is not supported on media fields")
          ));

      }
      if (
      file &&
      file.data &&
      file.supportingFile &&
      ((_file$supportingFile$ = file.supportingFile.mimetype) === null || _file$supportingFile$ === void 0 ? void 0 : _file$supportingFile$.search(/image\/*/)) !== -1 ||
      type === MediaModalType.Image)
      {
        return file !== null && file !== void 0 && file.fileURL ? /*#__PURE__*/
        _jsx("img", {
          src: file === null || file === void 0 ? void 0 : file.fileURL,
          alt: "",
          onError: () => {
            if (file !== null && file !== void 0 && file.fileURL) {
              setImageRenderError(true);
            }
          } }
        ) : /*#__PURE__*/

        // eslint-disable-next-line react/jsx-no-useless-fragment
        React.createElement(React.Fragment, null);

      }
      if (file !== null && file !== void 0 && file.fileURL) {
        return /*#__PURE__*/(
          _jsx(MarkdownMedia, {
            config: file === null || file === void 0 ? void 0 : file.fileURL,
            editing: true,
            onTimeLinkAdded: updateTimeLinks,
            type: file === null || file === void 0 ? void 0 : file.type }
          ));

      }
    })(), /*#__PURE__*/

    _jsx(MediaModal, {
      isOpen: openModal,
      onClose: handleCloseMediaModal,
      onChange: onChange,
      selectedUrl: file === null || file === void 0 ? void 0 : file.data,
      attachments: localAttachments,
      type: type,
      formModel: formModel,
      formField: formField,
      multipleEdition: multipleEdition }
    )
    ));

};

export default MediaField;